import { Logo } from '@/UI/Logo';
import { getUserLanguage } from '@/utils/langs';

export const Desktop = ({ children }: { children: any }) => {
  const lang = getUserLanguage();

  return (
    <>
      <div className="relative flex justify-center">
        <Logo className="absolute left-4 top-4 z-50" />
        <div className="mx-auto flex h-screen w-[330px] flex-shrink-0 items-center px-8 xl:w-[450px]">
          {children}
        </div>
        <div className="h-screen w-full max-w-[800px] p-5 xl:p-10">
          <div className="flex h-full w-full justify-end overflow-hidden rounded-lg bg-primary">
            <img
              className="h-full p-12 pr-0"
              src={`/images/auth/${lang === 'ru' ? 'ru' : 'en'}/auth_desktop.webp`}
              alt="bg"
            />
          </div>
        </div>
      </div>
    </>
  );
};
